import React, { useReducer } from 'react';
import LogContext from './logContext';
import LogReducer from './logReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_LOGS,
    ACTUALIZAR_LOG,
    LOG_ACTUAL,
    OBTENER_LOG,
    OBTENER_CANTIDAD_ALERTAS,
    LOG_ERROR,
    LOG_OK
} from 'types/context';

const LogState = props => {
    const initialState = {
        logs: [], // logs del cliente
        log: null,
        eventos: 0,
        cliente: null,
        mensaje: null
    }

    const [state, dispatch] = useReducer(LogReducer, initialState);

    /* 
    * Obtener los Logs 
    * tipo : 
    *   alertas = 1
    *   inactividad = 3
    *   totales = 1 y 3 
    */
    const obtenerLogs = async (clienteId, count, tipo) => {
        try {
            // siempre deberia venir un cliente
            let resultado;
            let tipoAlerta;
            switch (tipo) {
                case "alertas":
                    tipoAlerta = 1
                    break;
                case "inactividad":
                    tipoAlerta = 3
                    break;
                case "totales":
                    tipoAlerta = 4
                    break;
                default:
                    break;
            }

            const parametros = {
                params: {
                    count: count === "count" ? true : null
                }
            };

            if (clienteId) {
                /* resultado = await clienteAxios.get(`/logs/cliente/${clienteId}`, parametros); */
            } else {
                resultado = await clienteAxios.get(`/notificaciones/${tipo}`, parametros);
            }
            if (count) {
                dispatch({
                    type: OBTENER_CANTIDAD_ALERTAS,
                    payload: resultado.data.totalRegistros ? resultado.data.totalRegistros : 0
                });
            } else {
                dispatch({
                    type: OBTENER_LOGS,
                    payload: resultado.data.logs
                });
            }
            const { data } = resultado
            const alerts = {}

            switch (tipo) {
                case "alertas":
                    if ( count === "count" ) {
                        alerts["cantidadNotificacionesAlertas"] = data.cantidadNotificacionesAlertas || 0 ;
                    } else {
                        alerts["notificacionesAlertas"] = data.notificacionesAlertas || [];
                    }
                    break;
                case "inactividad":
                    if ( count === "count" ) {
                        alerts["cantidadNotificacionesInactividad"] = data.cantidadNotificacionesInactividad || 0 ;
                    } else {
                        alerts["notificacionesInactividad"] = data.notificacionesInactividad || [];
                    }
                    break;
                case "totales":
                    if ( count === "count" ) {
                        alerts["cantidadNotificacionesTotales"] = data.cantidadNotificacionesTotales || 0 ;
                    } else {
                        alerts["notificacionesTotales"] = data.notificacionesTotales || [];
                    }
                    break;
                default:
                    break;
            }
            
            return alerts;
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            dispatch({
                type: LOG_ERROR,
                payload: alerta
            })
        }
    }


    // Selecciona el log que el usuario dio click
    const logActual = logId => {
        dispatch({
            type: LOG_ACTUAL,
            payload: logId
        })
    }


    // Aactualizar log
    const actualizarLog = async log => {

        try {
            const resultado = await clienteAxios.put(`/log/${log._id}`, log);
            //console.log(resultado);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_LOG,
                payload: resultado.data.log
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: LOG_ERROR,
                payload: alerta
            })
        }
    }

    // Desactivar log
    const desactivarLog = async logID => {

        try {
            const resultado = await clienteAxios.put(`/log/desactivar/${logID}`);
            //console.log(resultado);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_LOG,
                payload: resultado.data.log
            })
            const alerta = {
                msg: "Log desactivado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: LOG_OK,
                payload: alerta
            })
            return alerta
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: LOG_ERROR,
                payload: alerta
            })
        }
    }

    // muestra un error de validacion
    const errorLog = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: LOG_ERROR,
            payload: alerta
        })
    }

    // Obtengo un log por id
    const obtenerLog = async (logId) => {
        alert('Obtener logs');
        try {

            const resultado = await clienteAxios.get(`/log/${logId}`);

            dispatch({
                type: OBTENER_LOG,
                payload: resultado.data.log
            })
            return resultado.data.log;

        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: LOG_ERROR,
                payload: alerta
            })
        }
    }
    const clearOkLog = () => {
        dispatch({
            type: LOG_OK,
            payload: null,
        });
      };
      const clearErrorLog = () => {
        dispatch({
            type: LOG_ERROR,
            payload: null,
        });
      };
    return (
        <LogContext.Provider
            value={{
                logs: state.logs,
                log: state.log,
                cliente: state.cliente,
                mensaje: state.mensaje,
                eventos: state.eventos,
                obtenerLogs,
                logActual,
                actualizarLog,
                errorLog,
                obtenerLog,
                desactivarLog,
                clearOkLog,
                clearErrorLog
            }}
        >{props.children}

        </LogContext.Provider>
    )
}
export default LogState;
